import { render, staticRenderFns } from "./TransactionReport.vue?vue&type=template&id=20afd4b3&scoped=true"
import script from "./TransactionReport.vue?vue&type=script&lang=js"
export * from "./TransactionReport.vue?vue&type=script&lang=js"
import style0 from "./TransactionReport.vue?vue&type=style&index=0&id=20afd4b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afd4b3",
  null
  
)

export default component.exports